
export class Analytics {
    private readonly _dataLayer = (window as any).dataLayer || [];

    constructor() {
    }

    Push = (category: string = undefined,
        action: string = undefined,
        label: string = undefined,
        value: number = undefined,
        event: string = undefined) => {

        this._dataLayer.push({
            category: category,
            action: action,
            label: label,
            value: value,
            event: event
        });
    }

    PushSearchTerm = (value: string) => {
        this.Push(undefined, value, undefined, undefined, "SearchEvent");
    }
}


// WEBPACK FOOTER //
// ./Static/javascript/modules/analytics.ts